<template>
  <div class="wrapper">
    <div class="con">
      <img src="@/assets/img/speakinglab/logo.png" class="logo" />
      <a href="https://youtu.be/WSLNaG07REc" style="margin-top: 50px; background: none; color: #fff; border: 2px solid #fff; font-family: '맑은고딕', 'MalgunGothic', san-serif" target="_blank">
        Speaking Lab 사용방법
      </a>
      <a href="https://kr.object.ncloudstorage.com/speakinglab2/android_apk/speaking_lab_20220310.apk">안드로이드 앱 다운받기</a>
      <!-- <a href="https://kr.object.ncloudstorage.com/ctmtutorapp/20220824/ctmtutorapp_20220824.apk">안드로이드 앱 다운받기</a> -->
      <!-- <a class="androidAppDown" @click="androidDown()">안드로이드 앱 다운받기</a> -->
      <a href="https://apps.apple.com/us/app/speakinglab/id6463774714">아이폰 앱 다운받기</a>
      <div class="bar"></div>
      <div class="box">
        <p>
          <span>※ 아이폰 기업용 앱 신뢰하기</span><br />
          - 아이폰 기업용 앱을 처음 열면 기기에서 해당 앱 개발자를 신뢰할 수 없다는 알림이 표시됩니다.<br /><br />
          1. 설정 > 일반 > 프로파일 또는 프로파일 및 기기 관리를 탭합니다.
          <br />
          2. 기업용 앱 제목 아래에 있는 개발자 프로파일 이름을 탭하여 이 개발자에 대한 신뢰를 설정합니다.<br />
        </p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  methods: {
    // androidDown() {
    //   alert("안드로이드 버전은 준비중 입니다.");
    // },
  },
};
</script>
<style lang="scss" scoped>
.androidAppDown {
  cursor: pointer;
}

.wrapper {
  background: #034da2;
  height: 100vh;
  font-family: "맑은고딕", "MalgunGothic", san-serif;
  margin: 0;
  display: flex;
  justify-content: center;
  align-items: center;
}
.con {
  max-width: 600px;
  margin: 0 auto;
  text-align: center;
}
.con img.logo {
  width: 100%;
  max-width: 400px;
}
.con img.code {
  display: block;
  margin: 30px auto 0 auto;
}
.con a {
  display: block;
  background: #fff;
  border-radius: 50px;
  max-width: 400px;
  width: 100%;
  margin: 0 auto;
  color: #034da2;
  font-weight: bold;
  text-decoration: none;
  padding: 15px 0;
  font-size: 20px;
  margin-top: 30px;
}
.use {
  background: none;
  color: #fff;
  border: 2px solid #fff;
}
.bar {
  width: 50px;
  margin: 30px auto;
  border-top: 1px solid #fff;
}
.box {
  width: 100%;
  background: #ffffff;
  padding: 20px 0;
  opacity: 0.7;
}
p {
  font-size: 14px;
  line-height: 22px;
  width: 95%;
  margin: 0 auto;
  text-align: left;
  word-break: keep-all;
}
p span {
  font-size: 18px;
  font-weight: bold;
}
@media screen and (max-width: 414px) {
  .con {
    padding-top: 15%;
  }
}
</style>
